<template>
	<section :class="['Login_Form', modalStyling ? 'Login_Form--modal' : '']">
		<form
			id="login"
			name="login"
			@submit.prevent="login"
			class="grid-container"
		>
			<div class="grid-x">
				<div class="cell">
					<h1 class="h2 Login_Form__title">{{ $t('login.loginText') }}</h1>
				</div>
				<div
					:class="
						modalStyling
							? 'cell small-12'
							: 'cell small-10 small-offset-1 medium-6 medium-offset-3 large-4 large-offset-4 gutter-top'
					"
				>
					<InputComponent
						:placeholderValue="$t('login.emailPlaceholder')"
						v-model="email"
						:autocomplete="'email'"
						:hasError="emailError"
						:whiteErrorColor="true"
						:lightTheme="!modalStyling"
						:errorMessage="emailErrorMessage"
					>
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M14.3 14.06l-.18-.06a7.1 7.1 0 003-6 5.07 5.07 0 00-5-5 5.07 5.07 0 00-5 5 7.11 7.11 0 003 6l-.18.09c-3.37 1.5-6.86 3-5.79 6.26l.22.68h15.5l.22-.68c1.07-3.24-2.42-4.79-5.79-6.29zM9.14 8a3 3 0 016 0c0 2.07-.89 3.59-3 4.92-2.14-1.33-3-2.85-3-4.92zM6 19c.18-.77 1.31-1.57 4.77-3.11.48-.22.92-.43 1.34-.66.42.23.87.44 1.35.66 3.54 1.54 4.62 2.34 4.79 3.11z"/></svg>
					</InputComponent>
				</div>
				<div
					:class="
						modalStyling
							? 'cell small-12'
							: 'cell small-10 small-offset-1 medium-6 medium-offset-3 large-4 large-offset-4'
					"
				>
					<InputComponent
						:placeholderValue="$t('login.passwordPlaceholder')"
						type="password"
						:autocomplete="'current-password'"
						v-model="password"
						:whiteErrorColor="true"
						:lightTheme="!modalStyling"
						:hasError="passwordError"
						:errorMessage="passwordErrorMessage"
					>
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M12 12a3 3 0 103 3 3 3 0 00-3-3zm0 4a1 1 0 111-1 1 1 0 01-1 1z"/><path d="M17 9V7A5 5 0 007 7v2a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3v-6a3 3 0 00-3-3zM9 7a3 3 0 016 0v2H9zm9 11a1 1 0 01-1 1H7a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1z"/></svg>
					</InputComponent>
				</div>
				<div v-if="!modalStyling" class="cell gutter-top-half">
					<router-link
						class="Login_Form__link white underline"
						:to="{ name: 'resetpassword' }"
					>
						{{ $t('login.forgotPasswordLink') }}
					</router-link>
				</div>
				<div
					:class="
						modalStyling
							? 'cell small-12 large-6 large-offset-3'
							: 'cell small-6 small-offset-3 medium-6 medium-offset-3 large-4 large-offset-4 gutter-top'
					"
				>
					<Button
						:class="['btn--dark-bg']"
						submit
						full
						:loading="loading"
						class="Login_Form__submit"
					>
						{{ $t('login.loginButton') }}
					</Button>
				</div>
				<div v-if="!modalStyling" class="cell">
					<router-link
						class="Login_Form__link white underline"
						:to="{ name: 'newaccount' }"
					>
						{{ $t('login.createAccountLink') }}
					</router-link>
				</div>
				<div v-if="modalStyling" class="cell gutter-bottom-half">
					<router-link
						class="Login_Form__link white underline"
						:to="{ name: 'resetpassword' }"
					>
						{{ $t('login.forgotPasswordLink') }}
					</router-link>
				</div>
			</div>
		</form>
	</section>
</template>

<script>
import Button from '../../../components/atoms/Button'
import InputComponent from '../../../components/atoms/InputComponent'
import store from '../../../vueX/store'

export default {
	name: 'Login_Form',
	components: {
		InputComponent,
		Button
	},
	props: {
		modalStyling: {
			type: Boolean,
			default: false
		}
	},
	data: () => {
		return {
			email: '',
			password: '',
			loading: false,
			emailError: false,
			emailErrorMessage: '',
			passwordError: false,
			passwordErrorMessage: ''
		}
	},
	methods: {
		login() {
			if (this.email && this.password) {
				this.loading = true
				this.passwordErrorMessage = ''
				this.emailErrorMessage = ''
				this.emailError = false
				this.passwordError = false

				store
					.dispatch('GET_AUTHENTICATE_USER', {
						user: this.email,
						password: this.password
					})
					.then(success => {
						this.loading = false
						if (success) {
							// Close login madal
							store.dispatch('TOGGLE_GLOBAL_MODAL', {
								showLoginForm: false,
								showTokenExpired: false
							})

							if (this.$route.name == 'login') {
								this.$router.push({ name: 'profile' })
							} else {
								this.$emit('close')
							}
						} else {
							this.passwordErrorMessage = this.$t('login.errorText')
						}
					})
			} else {
				if (!this.email) {
					this.emailError = true
					this.emailErrorMessage = this.$t('login.missingEmailAddress')
				}
				if (!this.password) {
					this.passwordError = true
					this.passwordErrorMessage = this.$t('login.missingPassword')
				}
			}
		}
	}
}
</script>

<style scoped lang="scss">
.Login_Form {
	&__title {
		color: white;
		text-align: center;
	}

	&__submit {
		margin-bottom: 20px;
	}

	.input__container {
		margin-bottom: 20px;
	}

	.gutter-top {
		margin-top: 50px;
	}
	.gutter-top-half {
		margin-top: 25px;
	}
	.gutter-bottom-half {
		margin-bottom: 25px;
	}

	&--modal {
		.Login_Form__title {
			color: #434449;
			font-size: 22px;
			line-height: 1;
			margin-bottom: 30px;
		}
		.Login_Form__link {
			color: #04befb;
		}
		.Login_Form__submit {
			margin-top: 15px;
			margin-bottom: 15px;
		}
	}
}
</style>
